import { AlertCircle, RefreshCw } from 'lucide-react';

import { AppIcon } from './AppIcon';
import { Button } from './button';

interface FormErrorBannerProps {
  message: string;
  correlationId?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function FormErrorBanner({
  message,
  correlationId,
  onRetry,
  retryLabel = 'Retry',
}: FormErrorBannerProps) {
  return (
    <div
      className="mb-4 rounded-md border border-destructive/25 bg-destructive/10 p-3 text-xs text-destructive"
      role="alert"
    >
      <div className="flex items-start gap-2">
        <AppIcon icon={AlertCircle} size="compact" variant="error" className="mt-0.5" />
        <div className="min-w-0 flex-1 space-y-1">
          <p className="font-medium">{message}</p>
          {correlationId && (
            <p className="text-[11px] text-destructive/80">Correlation ID: {correlationId}</p>
          )}
        </div>
        {onRetry && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-7 flex-shrink-0 gap-1 text-xs"
            onClick={onRetry}
          >
            <AppIcon icon={RefreshCw} size="compact" />
            {retryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}